// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width: number;
    height: number;
}

const EmptyBillingHistorySvg = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '152'}
        height={props.height ? props.height.toString() : '116'}
        viewBox='0 0 152 116'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            y='13.5'
            width='126'
            height='36'
            rx='5.625'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <rect
            x='21'
            y='54'
            width='130.5'
            height='37.5'
            rx='5.625'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <rect
            x='42.0417'
            y='14.0039'
            width='72.1826'
            height='88.3429'
            rx='3'
            fill='#28427B'
        />
        <rect
            x='34.5'
            width='75.7575'
            height='98.0391'
            rx='3'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='35.25'
            y='0.75'
            width='74.2575'
            height='96.5391'
            rx='2.25'
            stroke='#3F4350'
            strokeOpacity='0.8'
            strokeWidth='1.5'
        />
        <path
            d='M43.5 10.5H56.4282'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 75H85.5168'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 51H85.5168'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 16.5H67.2018'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 87H98.445'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 63H98.445'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 39H98.445'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M43.5 22.5H53.1962'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M57 22.5H66.6962'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            opacity='0.32'
            d='M93.211 114.582C84.2055 114.401 76.737 111.318 70.8056 105.332C64.8742 99.3451 61.7723 91.8887 61.5 82.9622C61.7677 74.0311 64.8696 66.5724 70.8056 60.586C76.7416 54.5996 84.2101 51.5162 93.211 51.3359C102.129 51.5208 109.554 54.6042 115.485 60.586C121.416 66.5678 124.518 74.0265 124.79 82.9622C124.514 91.8933 121.412 99.3497 115.485 105.332C109.558 111.313 102.134 114.397 93.211 114.582Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M94.4203 108.995C85.6017 108.816 78.3286 105.802 72.5478 99.9677C66.7635 94.1297 63.7313 86.8651 63.4598 78.1261C63.7268 69.3826 66.759 62.1159 72.5476 56.2781C78.3332 50.4434 85.6064 47.43 94.4202 47.2502C103.149 47.4345 110.379 50.4467 116.162 56.2781C121.946 62.1111 124.978 69.3777 125.25 78.1261C124.974 86.87 121.941 94.1345 116.162 99.9677C110.384 105.799 103.154 108.811 94.4203 108.995Z'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='1.5'
        />
        <path
            d='M94.2074 102.138C87.3234 102.001 81.6143 99.6419 77.0802 95.0625C72.5461 90.4831 70.175 84.7792 69.9668 77.9508C70.1714 71.1188 72.5426 65.4132 77.0802 60.8338C81.6178 56.2544 87.3269 53.8957 94.2074 53.7578C101.024 53.8993 106.7 56.2579 111.234 60.8338C115.768 65.4096 118.139 71.1153 118.347 77.9508C118.136 84.7828 115.765 90.4867 111.234 95.0625C106.703 99.6384 101.028 101.997 94.2074 102.138Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M94.2072 101.388C87.5103 101.251 81.9967 98.9622 77.6132 94.5348C73.2261 90.1039 70.9245 84.5918 70.7171 77.9506C70.921 71.3061 73.2226 65.7924 77.613 61.3617C82.0002 56.9341 87.5139 54.6454 94.2072 54.508C100.835 54.6488 106.316 56.9362 110.701 61.3617C115.088 65.7887 117.39 71.3023 117.597 77.9506C117.386 84.5955 115.084 90.1076 110.701 94.5348C106.32 98.96 100.839 101.247 94.2072 101.388Z'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeWidth='1.5'
        />
        <path
            d='M94.1567 51.9434V77.948L105.647 89.4384'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.8'
            strokeWidth='1.5'
            strokeLinejoin='round'
        />
        <circle
            cx='94.1571'
            cy='77.9464'
            r='2.41903'
            fill='var(--center-channel-color)'
            fillOpacity='0.8'
        />
    </svg>
);

export default EmptyBillingHistorySvg;
